import { USER_INIT } from '../constants/actionTypes'
import { fetchUserSavedSearches as fetchUserSavedSearchesProvider } from '../providers/user'

export const init = user => ({
  type: USER_INIT,
  user,
})

export const fetchUserSavedSearches = req => {
  return async dispatch => {
    const userSavedSearches = await fetchUserSavedSearchesProvider(req)
    return dispatch(init({ saved_searches: userSavedSearches }))
  }
}
